import { StubPage } from '../components/StubPage';

export function TnvedMatcherPage(): JSX.Element {
  return <StubPage navKey="tnvedMatcher" />;
}
